import React, {memo} from "react";
import { withStyles } from "@material-ui/core";
import Tooltip from "../../../components/common/StyledToolTip";
import styles from "./styles";

class GeoCode extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            isEnabled: this.props.isEnabled ?? false
        }
    }

    componentDidMount(){
        this.props.stack.layoutManager.eventHub.on(
            `${this.props.headerId}_ActivateGeocode`,
            this.activateGeocoding
          );
    }

    componentWillUnmount(){
        this.props.stack.layoutManager.eventHub.off(
            `${this.props.headerId}_ActivateGeocode`,
            this.activateGeocoding
          );
    }

    activateGeocoding = (enable) => {
        if (this.state.isEnabled !== enable ) {
            this.setState({
                isEnabled: enable
            })
        }
    }

    geocode = () => {
        if (this.state.isEnabled) {
            this.props.stack.layoutManager.eventHub.emit(`${this.props.headerId}_geocode`);
        }
    }

    render(){
        const {classes} =this.props;
        const {isEnabled} = this.state
        return(
            <div className={`${classes.headerIconStyles} 
                            ${classes.iconLayout} glHeaderIcons 
                            ${isEnabled ? classes.enabledIcon : classes.disableIcon}`}
                onClick={this.geocode}
            >
            <Tooltip
              title={ isEnabled
                    ? "Update location"
                  : "Select a single shipment to update location"
              }
            >
              <i className={`icon-geocoding ${classes.actionIcon}`} />
            </Tooltip>
          </div>
        )
    }
}

export default withStyles(styles)(memo(GeoCode))